import React, { useEffect, useState } from 'react';
import { Button, Modal, Radio, Stack, Text, Group } from '@mantine/core';
import { t } from 'i18next';
import { IHealthcareFacilityInfo } from '../../../global/entities/Login/CurrentUser.ts';

type ClinicSelectorModalProps = {
    opened: boolean;
    facilities: IHealthcareFacilityInfo[];
    onSelect: (facilityId: number) => void;
    onClose?: () => void;
    defaultFacilityId?: number;
};

export const ClinicSelectorModal: React.FC<ClinicSelectorModalProps> = ({ opened, facilities, onSelect, onClose, defaultFacilityId }) => {
    const [selectedId, setSelectedId] = useState<string | null>(defaultFacilityId ? String(defaultFacilityId) : null);

    useEffect(() => {
        if (opened && defaultFacilityId)
            setSelectedId(String(defaultFacilityId));
    }, [opened, defaultFacilityId]);
    const closable = !!onClose;

    return (
        <Modal
            opened={opened}
            onClose={onClose ?? (() => {})}
            title={t('clinicSelector.title')}
            size="sm"
            radius="md"
            withCloseButton={closable}
            closeOnClickOutside={closable}
            closeOnEscape={closable}
        >
            <Stack gap="sm">
                <Text size="sm">{t('clinicSelector.description')}</Text>

                <Radio.Group value={selectedId} onChange={setSelectedId}>
                    <Stack gap="xs" mt="xs">
                        {facilities.map((facility) => (
                            <Radio
                                key={facility.id}
                                value={String(facility.id)}
                                label={facility.name}
                            />
                        ))}
                    </Stack>
                </Radio.Group>

                <Group justify="flex-end" mt="md">
                    <Button
                        disabled={!selectedId}
                        onClick={() => onSelect(Number(selectedId))}
                    >
                        {t('button.confirm')}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
};
